import clsx from 'clsx';
import type { Card as CardType } from '@/types';
import CardBack from '@/assets/images/2-target-your-mate-card-back.jpg';
import { CARDS_FRONTS } from './config';

interface Props {
  card: CardType;
  onClick: () => void;
  isSelected?: boolean;
  skewToLeft?: boolean;
}

export const Card = ({ card, onClick, isSelected = false, skewToLeft = false }: Props) => (
  <div
    onClick={onClick}
    className={clsx(
      'relative cursor-pointer duration-500 preserve-3d transform-3d w-full md:w-48 mx-auto',
      card.isFlipped && 'rotate-y-180',
      card.isFlipped ? (skewToLeft ? 'skew-y-4 -skew-x-4' : '-skew-y-4 skew-x-4') : skewToLeft ? '-skew-y-4 skew-x-4' : 'skew-y-4 -skew-x-4',
    )}
  >
    {/* Card back (face-down) */}
    <img src={CardBack} alt=" " className="backface-hidden border-4 border-transparent p-1" />

    {/* Card front (face-up) */}
    <img
      src={CARDS_FRONTS[card.pairId]}
      alt=" "
      className={clsx(
        'absolute inset-0 backface-hidden rotate-y-180 border-4 p-1 border-dashed transition-colors duration-500 ease-in-out',
        isSelected ? 'border-light-green' : 'border-transparent',
      )}
    />
  </div>
);
